export enum ModalThemes {
  DEFAULT = 'default',
  UNITE = 'unite',
  JOIN_FLOW = 'join-flow'
}
